import { IdefaultSettings } from './SiteHeader.d'
import { getCoords } from '../../helpers'

export default class {
  defaultSettings: IdefaultSettings
  siteHeader: HTMLElement

  constructor(
    defaultSettings: IdefaultSettings = {
      setBodyPaddingTop: true,
      stickyHeader: true,
    },
  ) {
    this.defaultSettings = defaultSettings
    this.siteHeader = <HTMLElement>document.getElementById('masthead')
    this.init()
  }

  init() {
    if (this.siteHeader) {
      const siteHeaderHeight = this.siteHeader.clientHeight
      document.documentElement.style.setProperty('--site-header-height', `${siteHeaderHeight}px`)

      this.defaultSettings.stickyHeader === false || this.stickyHeader()
    }
  }

  stickyHeader() {
    if (window.pageYOffset > 0) {
      this.siteHeader.classList.add('sticky')
    }

    window.addEventListener('scroll', () => {
      const headerOffsetTop = getCoords(this.siteHeader).top

      if (headerOffsetTop > 0) this.siteHeader.classList.add('sticky')
      else this.siteHeader.classList.remove('sticky')
    })
  }
}
